/**
 * Picks the most cost-effective SKU from a generic group's pack-size variants.
 * Lowest cost per generic unit wins; larger pack breaks ties.
 *
 * @param {Array<{ productId: string, genericFactor: number, sellPrice: number, warehouseAvailablePacks?: number }>} products
 * @returns {{ productId: string, genericFactor: number, sellPrice: number } | null}
 */
function selectCostEffectiveSku (products) {
  if (!Array.isArray(products) || products.length === 0) return null

  // Only consider SKUs that have a valid pack size AND a positive price.
  const candidates = products.filter(p => p.genericFactor > 0 && p.sellPrice > 0)

  if (candidates.length === 0) return null

  return candidates.reduce((best, current) => {
    const currentCpu = current.sellPrice / current.genericFactor
    const bestCpu = best.sellPrice / best.genericFactor

    // Primary: prefer the cheaper option per generic unit
    if (currentCpu < bestCpu) return current

    // Tiebreaker: same unit cost → prefer the larger pack
    if (currentCpu === bestCpu && current.genericFactor > best.genericFactor) return current

    return best
  })
}

exports.selectCostEffectiveSku = selectCostEffectiveSku
